import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Avatar,
  Box,
  ButtonBase,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material';

// project imports
import { set_menu_open } from 'store/actions';
import { getStoredUsername } from 'utils/helpers';
import useLogout from 'hooks/useLogout';
import ThemeModeToggle from 'ui-component/ThemeModeToggle';
import LogoSection from '../LogoSection';

// assets
import { IconMenu2, IconLogout } from '@tabler/icons-react';

const mapDispatchToProps = (dispatch) => {
  return {
    setMenuOpen: (data) => dispatch(set_menu_open(data))
  };
};

const Header = ({ handleLeftDrawerToggle, setMenuOpen }) => {
  const theme = useTheme();
  const { logout } = useLogout();

  const username = getStoredUsername();

  const handleLogout = () => {
    setMenuOpen('default');
    logout({ returnToCurrentPage: false });
  };

  return (
    <>
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
            <LogoSection />
          </Box>
          <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
            <Avatar
              variant="rounded"
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                transition: 'all .2s ease-in-out',
                background: theme.palette.secondary.light,
                color: theme.palette.secondary.dark,
                '&:hover': {
                  background: theme.palette.secondary.dark,
                  color: theme.palette.secondary.light
                }
              }}
              onClick={handleLeftDrawerToggle}
              color="inherit"
            >
              <IconMenu2 stroke={1.5} size="1.3rem" />
            </Avatar>
          </ButtonBase>
        </div>
      </Box>

      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />

      {username && (
        <Box
          sx={{
            display: { xs: 'none', sm: 'flex' },
            alignItems: 'center',
            gap: 1,
            mr: 2,
            px: 1.5,
            py: 0.6,
            borderRadius: '12px',
            backgroundColor:
              theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : theme.palette.grey[100]
          }}
        >
          <Avatar
            sx={{
              width: 26,
              height: 26,
              fontSize: '0.8rem',
              fontWeight: 600,
              background: theme.palette.secondary.light,
              color: theme.palette.secondary.dark,
              textTransform: 'uppercase'
            }}
          >
            {username.charAt(0)}
          </Avatar>
          <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1 }}>
            {username}
          </Typography>
        </Box>
      )}

      <ThemeModeToggle sx={{ mr: 1 }} />

      <List
        component="nav"
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderRadius: '10px'
        }}
      >
        <ListItemButton
          sx={{
            borderRadius: `12px`,
            '&:hover .MuiTypography-root': {
              color: theme.palette.secondary.dark
            }
          }}
          onClick={handleLogout}
        >
          <ListItemIcon>
            <IconLogout stroke={1.5} size="1.3rem" />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2">Logout</Typography>} />
        </ListItemButton>
      </List>
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
  setMenuOpen: PropTypes.func
};

export default connect(null, mapDispatchToProps)(Header);
